export const TENANTS_PATH = '/tenants';
export const FETCH_TENANT_ERROR_TEXT = 'Failed to fetch tenant';
export const FETCH_TENANT_CACHE_KEY = 'tenant';
export const FETCH_TENANTS_CACHE_KEY = 'tenants';
export const CREATE_TENANT_ERROR_TEXT = 'Failed to create tenant';
export const EDIT_TENANT_ERROR_TEXT = 'Failed to edit tenant';
export const DELETE_TENANT_ERROR_TEXT = 'Failed to delete tenant';
